
export default function difference(original: Object, edited: Object){
    let diff = {};
    for (let key in original) {
        if (original[key] !== edited[key]) {
            diff[key] = edited[key];
        }
    }
    return diff;
};